export default __webpack_public_path__ + "media/images/testimonials/dashes-514e0177c2422592e052b98d32d735c7.svg";